<script>
import MembershipGeneralSettings from '@app/components/MembershipGeneralSettings.vue';
import MembershipSEOSettings from '@app/components/MembershipSEOSettings.vue';
import MembershipTagsForm from '@app/components/MembershipTagsForm.vue';
import MembershipWebhooksForm from '@app/components/MembershipWebhooksForm.vue';
import MembershipAfterForm from '@app/components/MembershipAfterForm.vue';
import MembershipPaymentSettings from '@app/components/MembershipPaymentSettings.vue';

export default {
  components: {
    MembershipAfterForm,
    MembershipGeneralSettings,
    MembershipPaymentSettings,
    MembershipSEOSettings,
    MembershipTagsForm,
    MembershipWebhooksForm,
  },
  head: {
    title: 'Paramètres',
  },
};
</script>

<template>
  <div>
    <AppToggleSection>
      <template #title>
        Général
      </template>
      <template #default>
        <MembershipGeneralSettings />
      </template>
    </AppToggleSection>
    <AppToggleSection>
      <template #title>
        Paiements et échecs
      </template>
      <template #default>
        <MembershipPaymentSettings />
      </template>
    </AppToggleSection>
    <AppToggleSection>
      <template #title>
        SEO (référencement)
      </template>
      <template #default>
        <MembershipSEOSettings />
      </template>
    </AppToggleSection>
    <AppToggleSection>
    <template #title>
      Après achat/inscription
    </template>
    <template #default>
      <MembershipAfterForm />
    </template>
  </AppToggleSection>
    <AppToggleSection>
      <template #title>
        <span style="display:flex;gap:8px;align-items: center;">
          Étiquettes
        </span>
      </template>
      <template #default>
        <MembershipTagsForm />
      </template>
    </AppToggleSection>

    <AppToggleSection>
      <template #title>
        Autorépondeur &amp; automatisation
      </template>
      <template #default>
        <MembershipWebhooksForm />
      </template>
    </AppToggleSection>
  </div>
</template>
